const config = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    DOMAIN_NAME: (process.env.REACT_APP_DOMAIN_NAME || '').replace(/\/+$/, ''),
    PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL || '/',
    // The Django origin that serves /documents/view/<path> (a plain, non-/api/
    // route) - derived from API_BASE_URL by stripping the trailing "api/".
    DJANGO_ORIGIN: (process.env.REACT_APP_API_BASE_URL || '').replace(/\/?api\/?$/, ''),
    WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
}

export default config;